var map = {
	"./big-five-diagram-nb.png": 4727,
	"./big-five-diagram.en.svg": 27645,
	"./big-five-diagram.xx.svg": 28092,
	"./gma-example-01.png": 94803,
	"./hardiness-nb.png": 52129,
	"./no-departments.svg": 45470,
	"./report-illustration.svg": 38030,
	"./skill-model-nb.png": 18035,
	"./skill-model.en.png": 59977,
	"./skill-model.nb.png": 83660,
	"./undraw_collaboration.svg": 64552,
	"./undraw_completed_tasks.svg": 55295,
	"./undraw_dashboard.svg": 15051,
	"./undraw_drag.svg": 51647,
	"./undraw_football_cards.svg": 59250,
	"./undraw_hire.svg": 25159,
	"./undraw_hiring.svg": 48162,
	"./undraw_report.svg": 66179,
	"./undraw_resume_folder.svg": 89891,
	"./undraw_selecting_team.svg": 96665,
	"./undraw_shared_goals.svg": 66871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5397;